// removed by extract-text-webpack-plugin
module.exports = {"StickyWrapper":"src-components-Header----index-module---StickyWrapper---2PH6w","StickyWrapper--sticky":"src-components-Header----index-module---StickyWrapper--sticky---34pH7","HeaderContainer":"src-components-Header----index-module---HeaderContainer---3Arx1","Logo":"src-components-Header----index-module---Logo---2Pp_A","HeaderRow":"src-components-Header----index-module---HeaderRow---27hwb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/index.module.scss
// module id = 316
// module chunks = 114276838955818